import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.stepRentalVehicle.sectionTitle',
    defaultMessage: 'Section 6 - Rental Vehicle Excess',
  },
  yes: {
    id: 'fastCover.stepRentalVehicle.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'fastCover.stepRentalVehicle.no',
    defaultMessage: 'No',
  },
  areYouClaimingForRentalVehicleExcess: {
    id: 'fastCover.stepRentalVehicle.areYouClaimingForRentalVehicleExcess',
    defaultMessage: 'Are you claiming for Rental Vehicle Excess?',
  },
  toAssistYourClaim: {
    id: 'fastCover.stepRentalVehicle.toAssistYourClaim',
    defaultMessage: 'To assist your claim:',
  },
  toAssistYourClaimDetail1: {
    id: 'fastCover.stepRentalVehicle.toAssistYourClaim',
    defaultMessage:
      'We may need the below documents, please provide those that are applicable.',
  },
  toAssistYourClaimDetail2: {
    id: 'fastCover.stepRentalVehicle.toAssistYourClaim',
    defaultMessage: 'We may contact you to request further documentation',
  },
  document: {
    id: 'fastCover.stepRentalVehicle.document',
    defaultMessage: 'Documents',
  },
  document1: {
    id: 'fastCover.stepRentalVehicle.document1',
    defaultMessage:
      'A full copy of your rental vehicle agreement. It must show the excess you were liable to pay under the agreement.',
  },
  document2: {
    id: 'fastCover.stepRentalVehicle.document2',
    defaultMessage:
      'A copy of the itemised invoice for the repairs to the rental vehicle.',
  },
  document3: {
    id: 'fastCover.stepRentalVehicle.document3',
    defaultMessage:
      'Copy of your Australian Drivers licence or Motorcycle licence and any international or foreign countries drivers or motorcycle licence.',
  },
  document4: {
    id: 'fastCover.stepRentalVehicle.document4',
    defaultMessage:
      'Copy of the police report or report to relevant authority.',
  },
  document5: {
    id: 'fastCover.stepRentalVehicle.document5',
    defaultMessage:
      'Copy of your credit card statement showing the amount paid for the rental vehicle excess.',
  },
  provideExplanation: {
    id: 'fastCover.stepRentalVehicle.provideExplanation',
    defaultMessage:
      'If you cannot provide any of the above documents, please provide an explanation why you are unable to.',
  },
  previousDescriptionOfWhatHappened: {
    id: 'fastCover.stepRentalVehicle.previousDescriptionOfWhatHappened',
    defaultMessage:
      'Include any additional information you may have to add to your previous description of what happened.',
  },
  nameOfThePersonDrivingTheCar: {
    id: 'fastCover.stepRentalVehicle.nameOfThePersonDrivingTheCar',
    defaultMessage: 'Name of the person driving the car',
  },
  driverDateOfBirth: {
    id: 'fastCover.stepRentalVehicle.driverDateOfBirth',
    defaultMessage: "Driver's Date of Birth",
  },
  dateOfExpense: {
    id: 'fastCover.stepRentalVehicle.dateOfExpense',
    defaultMessage: 'Date of Expense',
  },
  description: {
    id: 'fastCover.stepRentalVehicle.description',
    defaultMessage: 'Description',
  },
  descriptionEg: {
    id: 'fastCover.stepRentalVehicle.descriptionEg',
    defaultMessage: 'e.g.Flight to Paris',
  },
  rentalVehicleExcessAmount: {
    id: 'fastCover.stepRentalVehicle.rentalVehicleExcessAmount',
    defaultMessage: 'Rental Vehicle Excess charged',
  },
  currency: {
    id: 'fastCover.stepRentalVehicle.currency',
    defaultMessage: 'Currency',
  },
  currencyEg: {
    id: 'fastCover.stepRentalVehicle.currencyEg',
    defaultMessage: 'E.g.Euro',
  },
  actualRepairAmount: {
    id: 'fastCover.stepRentalVehicle.actualRepairAmount',
    defaultMessage: 'Actual Repair amount',
  },
  amountClaimed: {
    id: 'fastCover.stepRentalVehicle.amountClaimed',
    defaultMessage: 'Amount claimed',
  },
  isRequired: {
    id: 'fastCover.stepRentalVehicle.isRequired',
    defaultMessage: "'{defaultMessage}' is required",
  },
  other1: {
    id: 'fastCover.stepRentalVehicle.other1',
    defaultMessage: 'Your rental vehicle agreement that states the rental vehicle excess',
  },
  other2: {
    id: 'fastCover.stepRentalVehicle.other2',
    defaultMessage: 'A quote or repair invoice for the rental vehicle damage',
  },
  other3: {
    id: 'fastCover.stepRentalVehicle.other3',
    defaultMessage: 'Copy of your Australian Drivers license or motorcycle license and any other international drivers or motorcycle license.',
  },
  other4: {
    id: 'fastCover.stepRentalVehicle.other4',
    defaultMessage: 'A police or accident report from the relevant authority',
  },
  other5: {
    id: 'fastCover.stepRentalVehicle.other5',
    defaultMessage: 'Copy of your bank or credit card statement showing the amount paid for the rental vehicle excess',
  },
});



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepRentalVehicle/messages.js